import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";
import routes from "../utils/routes";
import { getUserToken } from "../utils/tokenHandler";

const getUserDetails = async () => {
  const { data } = await axiosInstance.get(paths.user);

  return data;
};

export const getSessionUserDetailsQueryEnabled = () => {
  const hasToken = getUserToken();
  const isSSOWarning =
    typeof window !== "undefined" &&
    window.location.pathname === routes.private.sso_warning;
  return Boolean(hasToken && !isSSOWarning);
};

export const useUserDetails = ({ enabled, retry = false }) => {
  return useQuery({
    queryKey: ["userDetails"],
    queryFn: getUserDetails,
    enabled: enabled,
    retry: retry,
  });
};

/** Shared user query when a session token exists (and not on SSO warning). */
export const useSessionUserDetails = ({ retry = false } = {}) => {
  return useQuery({
    queryKey: ["userDetails"],
    queryFn: getUserDetails,
    enabled: getSessionUserDetailsQueryEnabled(),
    retry,
  });
};